import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { getPartnerContactsCrud } from '../lib/getPartnerContactsCrud'
import { UPDATE_CONTACT } from '../model/constants'
import { IPartnerContact } from '../model/types'
import { selectContactsFilters } from '../selectors/selectContactsFilters'

export const updateContact = createAsyncThunk<IPartnerContact, IPartnerContact>(
  UPDATE_CONTACT,
  async (editItem, { getState }) => {
    const { partnerId, programType } = selectContactsFilters(getState())
    const crud = getPartnerContactsCrud({ partnerId, programType })

    await crud.update({ formId: '700', code: 'PartnerContacts' }, [editItem])

    return editItem
  }
)
